import { defineStore } from "pinia";
import type { TransactionType } from "@/interface/common/location_inteface";
import { TransactionTypeServices } from "@/service/common/transaction_type_service";

export const useTransactionStore = defineStore("useTransactionStore", {
  state: (): {
    transactions: TransactionType[];
    isLoading: boolean;
    error: string | null;
  } => ({
    transactions: [] as TransactionType[],
    isLoading: false,
    error: null
  }),
  persist: false,
  getters: {},
  actions: {
    async fetchTransaction(): Promise<void> {
      this.isLoading = true;
      this.error = null;
      try {
        const service = new TransactionTypeServices();
        const transaction = await service.fetchTransaction();
        this.transactions = transaction;
        this.filtertransaction(transaction[0].value);
      } catch (e: any) {
        this.isLoading = false;
        this.error = e.message || "Unknown error occurred";
      }
    },

    // Update the entire transaction data
    updateTransactionData(transaction: TransactionType[]): void {
      this.transactions = transaction;
    }
  }
});
